export default "__VITE_ASSET__CGPAQbUq__"